module.exports = __webpack_public_path__ + "media/images/top/keisan_club_tensaku-052fef2b0b8b0fda112601f674522b1c.png";